module.exports = __webpack_public_path__ + "50850efe1151c7b39fe48c8dc2c6f5a6.png";